import styled from '@emotion/styled'

export const InfoIconContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-left: ${({ theme }) => theme.spacing(1)};
  label: InfoIconContainer;
`
